
import SettingsIcon from '@mui/icons-material/Settings';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';


const RMMgmt = {
  id: '9',
  title: 'RM Mgmt',
  type: 'group',
  role:'PHARMA_OMS_RM,PHARMA_OMS_PROD, PHARMA_OMS_PACKAGING',
  children: [
    {
          id: 'tasklist',
          title: 'My Task(s)',
          type: 'item',
          url: '/',
          bottomMenu:'MYTASKS',
          icon: FormatListNumberedIcon
        },
    // {
    //   id: 'rawdemand',
    //   title: 'Demand',
    //   type: 'item',
    //   url: '/rawdemand',
    //   icon: SettingsIcon
    // },{
    //   id: 'rmvendor',
    //   title: 'Vendor',
    //   type: 'item',
    //   url: '/rmvendor',
    //   icon: SettingsIcon
    // },{
    //   id: 'product',
    //   title: 'Product ',
    //   type: 'item',
    //   url: '/product',
    //   icon: SettingsIcon
    // },{
    //   id: 'rawmaterial',
    //   title: 'Raw Material',
    //   type: 'item',
    //   url: '/rawmaterial',
    //   icon: SettingsIcon
    // },
  ]
};

export default RMMgmt;